import React from 'react';

import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import useBridgeAPI from './useBridgeAPI';

const BridgeAPI = () => {
  useBridgeAPI();

  return <FullScreenLoader />;
};

export default BridgeAPI;
